export default __webpack_public_path__ + "static/media/x.83af43c5.svg";